module.exports = __webpack_public_path__ + "img/s1_t1_08.2598dfd9.jpeg";